import * as AQL from '@infl-ts/util-aql-gen';

var convertTermToAql = function convertTermToAql(term, groupId) {
  return AQL.all([AQL.any([AQL.field({
    field: 'name',
    operator: '$substring',
    string_value: term
  }), AQL.field({
    field: 'email',
    operator: '$substring',
    string_value: term
  }), AQL.field({
    field: 'title',
    operator: '$substring',
    string_value: term
  }), AQL.field({
    field: 'company',
    operator: '$substring',
    string_value: term
  })]), AQL.any(groupId ? [{
    group_id: groupId
  }] : [])]);
};

export default convertTermToAql;